<section>
	<main>
		<div class="message-block" [class.error-icon]="onlyCancel">
      <i *ngIf="viewIcon && !icon?.includes('static/')" class="pi {{ icon }}"></i>
      <img *ngIf="viewIcon && icon?.includes('static/')" src="{{ icon }}" alt="">
      <span class="message-text">
        {{ message }}
      </span>
		</div>
		<div *ngIf="subMessage" class="message-block">
      <span class="message-text">
        {{ subMessage }}
      </span>
		</div>
    <ng-container *ngIf="showStatus">
      <div class="status-block">
        <p-checkbox [(ngModel)]="checkedStatus" [binary]="true" inputId="binary"></p-checkbox>
        <span i18n class="status-text">
          Больше не показывать это сообщение.
        </span>
      </div>
    </ng-container>
	</main>
  <hr>
	<footer [class.change-btn-position]="changeBtnsPosition">
		<button
      *ngIf="!onlyCancel"
      appSkin="{{['KZ', 'ME-RU', 'ME'].includes(env.project) || actionButton ? 'action' : ''}} no-shadow bold bordered"
      [class.blue-action]="!['KZ', 'ME-RU', 'ME'].includes(env.project) || !actionButton"
      type="button"
      (click)="close(true)">
      {{ successButtonName }}
    </button>
		<button *ngIf="!!continueButtonName" appSkin="simple no-shadow bold bordered" type="button" (click)="continue()">{{ continueButtonName }}</button>
		<button appSkin="simple no-shadow bold bordered" type="button" (click)="close()">{{ cancelButtonName }}</button>
	</footer>
</section>
